import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-entitlement',
  templateUrl: './add-entitlement.component.html',
})
export class AddEntitlementComponent implements OnInit {

  public leaveTypes:string;
  public cboxCurrent:boolean=false;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/add-entitlement/add-entitlement.component.ts